import { getAncestorsUrl } from './helpers';

export const GET_ANCESTORS_SUCCESS = 'topbanner/GET_ANESTORS_SUCCESS';

const onSuccess = ({ content }) => {
  const ancestors = content.ancestors || [];
  return {
    type: GET_ANCESTORS_SUCCESS,
    payload: { ancestors },
  };
};

export const getAncestorsAction = (categoryId, platform) => {
  const apiEndpoint = getAncestorsUrl(categoryId, platform);

  if (!apiEndpoint) {
    return {};
  }

  return {
    payload: {
      url: apiEndpoint,
      method: 'GET',
      onSuccess,
      timeout: Number.parseInt(process.env.TOPBANNER_TIMEOUT, 10) || 2000,
    },
  };
};
